import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

//amplify agregar siempre estas librerias
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';

//fetchAuthSession importa los campos de autenticacaion
import '@aws-amplify/ui-react/styles.css';
import config from './amplifyconfiguration.json';

Amplify.configure(config);


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

const formFields = {
  signIn: {
    username: {
      placeholder: 'Cuenta de correo',
    },
    password: {
      placeholder: 'Mayusculas, minusculas y un numero',
    },
  },
  signUp: {
    username: {
      label: 'Username:',
      placeholder: 'Cuenta de correo',
      isRequired: true,
      order: 1,
    },
    name: {
      label: 'Nombre:',
      placeholder: 'Su Nombre completo',
      isRequired: true,
      order: 2,
    },
    password: {
      label: 'Password:',
      placeholder: 'Mayusculas, minusculas y un numero',
      isRequired: true,
      order: 3,
    },
    confirm_password: {
      label: 'Confirmar password:',
      placeholder: 'Mayusculas, minusculas y un numero',
      isRequired: true,
      order: 4,
    },
    phone_number:{
      label: "Celular",
      placeholder: "",
      isRequired: true,
      dialCode: '+57',
      order: 5,
    },
    }
  }

class App extends Component {
  render() {
    return (
      <Authenticator formFields={formFields}>
      <main>
        <HashRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </HashRouter>
      </main>
    </Authenticator>
    )
  }
}

export default App
